import { useEffect, useRef, useState } from 'react';
import mermaid from 'mermaid';

mermaid.initialize({
  startOnLoad: false,
  theme: 'base',
  themeVariables: {
    primaryColor: '#4f46e5',
    primaryTextColor: '#fff',
    primaryBorderColor: '#4338ca',
    lineColor: '#64748b',
    secondaryColor: '#f1f5f9',
    tertiaryColor: '#e2e8f0',
    textColor: '#334155',
    mainBkg: '#4f46e5',
    signalColor: '#334155',
    signalTextColor: '#334155',
    labelBoxBkgColor: '#4f46e5',
    labelBoxBorderColor: '#4338ca',
    labelTextColor: '#fff',
    loopTextColor: '#334155',
    noteBkgColor: '#fff5ad',
    noteTextColor: '#333',
    noteBorderColor: '#e2c846',
    actorBkg: '#4f46e5',
    actorBorder: '#4338ca',
    actorTextColor: '#fff',
    activationBkgColor: '#f1f5f9',
    activationBorderColor: '#cbd5e1',
    sequenceNumberColor: '#fff',
  },
});

interface MermaidDiagramProps {
  chart: string;
  caption?: string;
}

export function MermaidDiagram({ chart, caption }: MermaidDiagramProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const renderDiagram = async () => {
      if (!containerRef.current) return;

      try {
        containerRef.current.innerHTML = '';
        const id = `mermaid-${Math.random().toString(36).substring(2, 9)}`;
        const { svg } = await mermaid.render(id, chart);
        containerRef.current.innerHTML = svg;
        setError(null);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to render diagram');
      }
    };

    renderDiagram();
  }, [chart]);

  if (error) {
    return (
      <div className="my-6 p-4 bg-red-50 border border-red-200 rounded-lg">
        <p className="text-sm text-red-700">Error rendering diagram: {error}</p>
      </div>
    );
  }

  return (
    <figure className="my-6">
      <div
        ref={containerRef}
        className="p-4 bg-white border border-slate-200 rounded-lg overflow-x-auto flex justify-center"
      />
      {caption && (
        <figcaption className="mt-2 text-sm text-center text-slate-500">{caption}</figcaption>
      )}
    </figure>
  );
}
